"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards) {
        var widgets;
        (function (widgets) {
            function render(element, component) {
                const chartEl = element.find('.chart').empty();
                const definition = distill.componentManager.getDefinition(component.type);
                if (!definition)
                    return;
                if (component.type === dashboards.ComponentType.table) {
                    chartEl.removeClass('text-center');
                    return renderTable(element, chartEl, component);
                }
                else if (component.type === dashboards.ComponentType.distillQuery)
                    return renderDistillQuery(element, chartEl, component);
                else if (component.type === dashboards.ComponentType.valueLabel)
                    return renderValueLabel(element, chartEl, component);
                else if (component.type === dashboards.ComponentType.heading)
                    return renderHeading(element, chartEl, component);
            }
            widgets.render = render;
            function _formatValueLabel(val, component, isAbsoluteTrend = false) {
                var _a, _b, _c;
                const prefix = ((_a = component.styling) === null || _a === void 0 ? void 0 : _a.valuePrefix) || '';
                const suffix = ((_b = component.styling) === null || _b === void 0 ? void 0 : _b.valueSuffix) || '';
                if (val === null || val === undefined)
                    return '-';
                if (typeof val === 'number') {
                    const num = isAbsoluteTrend ? Math.abs(val) : val;
                    const options = {};
                    if (((_c = component.styling) === null || _c === void 0 ? void 0 : _c.valueDecimals) != null && component.styling.valueDecimals >= 0) {
                        options.minimumFractionDigits = component.styling.valueDecimals;
                        options.maximumFractionDigits = component.styling.valueDecimals;
                    }
                    return prefix + num.toLocaleString(undefined, options) + suffix;
                }
                return prefix + val + suffix;
            }
            function _processValueLabelData(component, rawData) {
                var _a, _b, _c, _d, _e, _f;
                let rawVal = null;
                let trendPercent = null;
                let trendDiff = null;
                let sparklineData = [];
                let sparklineLabels = [];
                if (rawData && rawData.ObjectResult && rawData.ObjectResult.length > 0) {
                    const rows = rawData.ObjectResult;
                    const dataQuery0 = component.dataQuery0;
                    const metricDef = (_b = (_a = dataQuery0 === null || dataQuery0 === void 0 ? void 0 : dataQuery0.aggregation) === null || _a === void 0 ? void 0 : _a.metrics) === null || _b === void 0 ? void 0 : _b[0];
                    const headerKey = metricDef ? distill.dashboards.getExpectedMetricHeader(component, dataQuery0, metricDef, 0) : rawData.Headers[0];
                    const metricFunction = (metricDef === null || metricDef === void 0 ? void 0 : metricDef.function) || 'Sum';
                    const isMax = metricFunction === 'Max';
                    const isMin = metricFunction === 'Min';
                    const isAvg = metricFunction === 'Avg';
                    const isDistinct = metricFunction === 'CountDistinct';
                    if (headerKey) {
                        const isHistory = !!((_d = (_c = dataQuery0 === null || dataQuery0 === void 0 ? void 0 : dataQuery0.aggregation) === null || _c === void 0 ? void 0 : _c.groupBy) === null || _d === void 0 ? void 0 : _d.columnId);
                        const groupByCol = (_e = dataQuery0 === null || dataQuery0 === void 0 ? void 0 : dataQuery0.aggregation) === null || _e === void 0 ? void 0 : _e.groupBy;
                        const timeGrain = (groupByCol === null || groupByCol === void 0 ? void 0 : groupByCol.timeGrain) || distill.dashboards.InsightTimeGrain.None;
                        let orderedValues = [];
                        let orderedLabels = [];
                        const calcAggregate = (vals) => {
                            if (isMax)
                                return Math.max(...vals);
                            if (isMin)
                                return Math.min(...vals);
                            if (isAvg)
                                return vals.reduce((a, b) => a + b, 0) / vals.length;
                            if (isDistinct)
                                return Math.max(...vals);
                            return vals.reduce((a, b) => a + b, 0);
                        };
                        orderedValues = rows.map(r => { const v = Number(r[headerKey]); return isNaN(v) ? null : v; });
                        const allValues = orderedValues.filter(v => v !== null);
                        const mode = ((_f = component.layout) === null || _f === void 0 ? void 0 : _f.summaryMode) || 'Latest Value';
                        if (mode === 'Latest Value') {
                            if (allValues.length > 0)
                                rawVal = allValues[allValues.length - 1];
                            if (isHistory && allValues.length > 1) {
                                const curr = allValues[allValues.length - 1];
                                const prev = allValues[allValues.length - 2];
                                trendDiff = curr - prev;
                                if (prev !== 0)
                                    trendPercent = (trendDiff / Math.abs(prev)) * 100;
                            }
                        }
                        else {
                            rawVal = calcAggregate(allValues);
                        }
                        if (isHistory) {
                            sparklineData = orderedValues;
                            sparklineLabels = orderedLabels;
                        }
                    }
                }
                return { rawVal, trendPercent, trendDiff, sparklineData, sparklineLabels };
            }
            function _calculateValueLabelState(component, rawVal) {
                var _a, _b, _c;
                if (!((_a = component.styling) === null || _a === void 0 ? void 0 : _a.enableThresholds) || rawVal === null)
                    return 'Normal';
                let valueToCompare = rawVal;
                const usePercent = component.styling.thresholdType === 'PercentOfTarget';
                if (usePercent && component.targetValue)
                    valueToCompare = (rawVal / component.targetValue) * 100;
                if (usePercent && !component.targetValue)
                    return 'Normal';
                const t1 = (_b = component.styling.warningThreshold) !== null && _b !== void 0 ? _b : 0;
                const t2 = (_c = component.styling.dangerThreshold) !== null && _c !== void 0 ? _c : 0;
                const isInverted = component.styling.thresholdLogic === 'Inverted';
                if (!isInverted) {
                    const criticalLimit = Math.min(t1, t2);
                    const warningLimit = Math.max(t1, t2);
                    if (valueToCompare < criticalLimit)
                        return 'Critical';
                    if (valueToCompare < warningLimit)
                        return 'Warning';
                }
                else {
                    const criticalLimit = Math.max(t1, t2);
                    const warningLimit = Math.min(t1, t2);
                    if (valueToCompare > criticalLimit)
                        return 'Critical';
                    if (valueToCompare > warningLimit)
                        return 'Warning';
                }
                return 'Normal';
            }
            function _getValueLabelStyles(component, state, trendValue) {
                var _a, _b, _c, _d, _e, _f, _g;
                const stateColors = {
                    Normal: { bg: component.bgColor || '#ffffff', text: ((_a = component.styling) === null || _a === void 0 ? void 0 : _a.valueColor) || '#2c3e50', badgeBg: '#dcfce7', badgeText: '#166534' },
                    Warning: { bg: '#fff7ed', text: '#c2410c', badgeBg: '#ffedd5', badgeText: '#9a3412' },
                    Critical: { bg: '#fef2f2', text: '#b91c1c', badgeBg: '#fee2e2', badgeText: '#991b1b' }
                };
                const isPositive = trendValue >= 0;
                if (state === 'Normal') {
                    const isGood = ((_b = component.styling) === null || _b === void 0 ? void 0 : _b.trendColorMode) === 'Inverted' ? !isPositive : isPositive;
                    if (!isGood) {
                        stateColors.Normal.badgeBg = '#fee2e2';
                        stateColors.Normal.badgeText = '#991b1b';
                    }
                }
                if (((_c = component.styling) === null || _c === void 0 ? void 0 : _c.applyConditionTo) === 'Card' && state !== 'Normal') {
                    stateColors.Warning = { bg: '#ea580c', text: '#ffffff', badgeBg: 'rgba(255,255,255,0.2)', badgeText: '#fff' };
                    stateColors.Critical = { bg: '#dc2626', text: '#ffffff', badgeBg: 'rgba(255,255,255,0.2)', badgeText: '#fff' };
                }
                const active = stateColors[state];
                const applyToCard = ((_d = component.styling) === null || _d === void 0 ? void 0 : _d.applyConditionTo) === 'Card' && state !== 'Normal';
                const applyToText = ((_e = component.styling) === null || _e === void 0 ? void 0 : _e.applyConditionTo) === 'Text' && state !== 'Normal';
                const applyToValue = ((_f = component.styling) === null || _f === void 0 ? void 0 : _f.applyConditionTo) === 'Value' && state !== 'Normal';
                const finalCardBg = applyToCard ? active.bg : (component.bgColor || '#fff');
                const finalCardText = applyToCard ? active.text : (((_g = component.styling) === null || _g === void 0 ? void 0 : _g.valueColor) || '#2c3e50');
                return { active, applyToCard, applyToText, applyToValue, finalCardBg, finalCardText };
            }
            function _buildValueLabelDOM(container, component, metrics, styles, isDesigner) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                container.empty();
                const $card = $('<div>').addClass('metric-card');
                $card.addClass('card-shadow');
                if (styles.applyToCard)
                    $card.addClass('card-solid');
                const hasTrend = (((_a = component.layout) === null || _a === void 0 ? void 0 : _a.showTrend) !== false) && (metrics.trendPercent !== null || metrics.trendDiff !== null);
                if (!hasTrend)
                    $card.addClass('mc-centered');
                $card.css({ 'background-color': styles.finalCardBg, 'color': styles.finalCardText });
                if (metrics.state !== 'Normal' && !styles.applyToCard)
                    $card.css('border', `1px solid ${metrics.state === 'Warning' ? '#fdba74' : '#fca5a5'}`);
                if (!isDesigner) {
                    const labelColor = (styles.applyToText && !styles.applyToCard) ? styles.active.text : 'inherit';
                    const labelText = ((_b = component.label) === null || _b === void 0 ? void 0 : _b.eng) || component.name || "Metric";
                    const $label = $('<div>').addClass('mc-label').text(labelText).css('color', labelColor);
                    if (component.labelStyle) {
                        if (component.labelStyle.color)
                            $label.css('color', component.labelStyle.color);
                        if (component.labelStyle.size)
                            $label.css('font-size', component.labelStyle.size);
                        if (component.labelStyle.decor === 'Bold')
                            $label.css('font-weight', 'bold');
                        if (component.labelStyle.decor === 'Italic')
                            $label.css('font-style', 'italic');
                    }
                    $card.append($label);
                    if ((_c = component.hint) === null || _c === void 0 ? void 0 : _c.eng) {
                        const $hint = $('<div>').addClass('mc-hint').text(component.hint.eng);
                        if (component.hintStyle) {
                            if (component.hintStyle.color)
                                $hint.css('color', component.hintStyle.color);
                            if (component.hintStyle.size)
                                $hint.css('font-size', component.hintStyle.size);
                            if (component.hintStyle.decor === 'Bold')
                                $hint.css('font-weight', 'bold');
                            if (component.hintStyle.decor === 'Italic')
                                $hint.css('font-style', 'italic');
                        }
                        else {
                            $hint.css('color', labelColor).css('opacity', '0.6');
                        }
                        $card.append($hint);
                    }
                }
                const $valueRow = $('<div>').addClass('mc-value-row');
                const valueColor = (styles.applyToValue || (styles.applyToText && !styles.applyToCard)) ? styles.active.text : 'inherit';
                const $value = $('<div>').addClass('mc-value').text(metrics.mainValue).css('color', valueColor);
                $valueRow.append($value);
                if (hasTrend) {
                    const trendValue = (_e = (_d = metrics.trendPercent) !== null && _d !== void 0 ? _d : metrics.trendDiff) !== null && _e !== void 0 ? _e : 0;
                    const isPositive = trendValue >= 0;
                    const arrow = isPositive ? '↑' : '↓';
                    const displayMode = ((_f = component.layout) === null || _f === void 0 ? void 0 : _f.trendDisplayMode) || 'Percent';
                    let text = '';
                    const pctText = metrics.trendPercent !== null ? `${Math.abs(metrics.trendPercent).toFixed(1)}%` : '-';
                    const absText = metrics.trendDiff !== null ? _formatValueLabel(metrics.trendDiff, component, true) : '-';
                    if (displayMode === 'Percent')
                        text = `${arrow} ${pctText}`;
                    else if (displayMode === 'Absolute')
                        text = `${arrow} ${absText}`;
                    else if (displayMode === 'Both')
                        text = `${arrow} ${pctText} (${absText})`;
                    const $trendBadge = $('<div>').addClass('mc-trend-badge').text(text);
                    $trendBadge.css({ 'background-color': styles.active.badgeBg, 'color': styles.active.badgeText });
                    $valueRow.append($trendBadge);
                }
                $card.append($valueRow);
                if (((_g = component.layout) === null || _g === void 0 ? void 0 : _g.showProgressBar) && metrics.progressPercent !== null) {
                    const $footer = $('<div>').addClass('mc-footer');
                    const $progressContainer = $('<div>').addClass('mc-progress-container mc-progress-bg');
                    const barColor = (styles.applyToCard) ? '#ffffff' : (((_h = component.styling) === null || _h === void 0 ? void 0 : _h.valueColor) || '#2c3e50');
                    const $bar = $('<div>').addClass('mc-progress-fill').css({ 'width': `${metrics.progressPercent}%`, 'background-color': barColor });
                    $progressContainer.append($bar);
                    $footer.append($progressContainer);
                    $card.append($footer);
                }
                if (((_j = component.layout) === null || _j === void 0 ? void 0 : _j.kpiStyle) === 'Sparkline' && metrics.sparklineData.length > 1) {
                    const sparkId = `spark_${component.id}`;
                    const $sparkEl = $(`<div id="${sparkId}"></div>`).addClass('mc-sparkline');
                    $card.append($sparkEl);
                    setTimeout(() => {
                        var _a;
                        const el = document.getElementById(sparkId);
                        if (el) {
                            let chart = echarts.getInstanceByDom(el);
                            if (!chart)
                                chart = echarts.init(el);
                            const baseColor = ((_a = component.styling) === null || _a === void 0 ? void 0 : _a.sparklineColor) || '#e0e7ff';
                            const finalSparkColor = (styles.applyToCard) ? '#ffffff' : baseColor;
                            chart.setOption({
                                tooltip: {
                                    trigger: 'axis',
                                    formatter: (params) => {
                                        const label = params[0].name;
                                        const value = params[0].value;
                                        const valDisplay = value !== null ? value.toLocaleString() : 'No data';
                                        return `<div style="font-size:12px;font-weight:bold">${label}</div><div>${valDisplay}</div>`;
                                    }
                                },
                                grid: { left: 5, right: 5, bottom: 5, top: '20%' },
                                xAxis: {
                                    type: 'category',
                                    data: metrics.sparklineLabels,
                                    show: false,
                                    boundaryGap: false
                                },
                                yAxis: { type: 'value', show: false, scale: true },
                                series: [{
                                        data: metrics.sparklineData,
                                        type: 'line',
                                        smooth: true,
                                        showSymbol: false,
                                        lineStyle: { width: 2, color: finalSparkColor },
                                        areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: finalSparkColor }, { offset: 1, color: 'rgba(255, 255, 255, 0)' }]) }
                                    }]
                            });
                            new ResizeObserver(() => chart.resize()).observe(el);
                        }
                    }, 0);
                }
                container.append($card);
            }
            function _setupValueLabelResponsiveScaling(element) {
                const $card = element.find('.metric-card');
                if (!$card.length)
                    return;
                const existingObserver = element.data('resizeObserver');
                if (existingObserver instanceof ResizeObserver) {
                    existingObserver.disconnect();
                }
                const updateScale = () => {
                    const width = element.width() || 250;
                    const height = element.height() || 150;
                    const scaleW = width / 250;
                    const scaleH = height / 150;
                    const scale = Math.min(scaleW, scaleH);
                    const fontSize = Math.max(10, Math.min(18, 16 * scale));
                    $card.css('font-size', `${fontSize}px`);
                };
                const resizeObserver = new ResizeObserver(() => updateScale());
                resizeObserver.observe(element.get(0));
                element.data('resizeObserver', resizeObserver);
                updateScale();
            }
            function renderValueLabel(element, container, component) {
                var _a;
                const dataQueryPropName = 'dataQuery0';
                const cacheKey = `${component.id}.${dataQueryPropName}`;
                const rawData = dashboards.dataManager.getCachedResult(cacheKey);
                const dashComponent = component;
                const $header = element.find('.card-header');
                const isDesigner = $('body').hasClass('designerv2');
                if (isDesigner) {
                    $header.removeClass('d-none');
                }
                else {
                    $header.addClass('d-none');
                    element.find('.card-body').css('height', '100%');
                }
                const { rawVal, trendPercent, trendDiff, sparklineData, sparklineLabels } = _processValueLabelData(dashComponent, rawData);
                const metrics = {
                    rawVal: rawVal,
                    trendPercent: trendPercent,
                    trendDiff: trendDiff,
                    sparklineData: sparklineData,
                    sparklineLabels: sparklineLabels,
                    mainValue: _formatValueLabel(rawVal, dashComponent),
                    progressPercent: (dashComponent.targetValue && rawVal !== null) ? Math.min((rawVal / dashComponent.targetValue) * 100, 100) : null,
                    state: _calculateValueLabelState(dashComponent, rawVal)
                };
                const trendValue = (_a = trendPercent !== null && trendPercent !== void 0 ? trendPercent : trendDiff) !== null && _a !== void 0 ? _a : 0;
                const styles = _getValueLabelStyles(dashComponent, metrics.state, trendValue);
                _buildValueLabelDOM(container, dashComponent, metrics, styles, isDesigner);
                _setupValueLabelResponsiveScaling(element);
            }
            function renderHeading(element, chartEl, component) {
                var _a, _b, _c, _d, _e;
                const dashComponent = component;
                chartEl.empty();
                const $container = $('<div>').addClass('heading-content');
                $container.css({
                    'justify-content': getFlexAlign((_a = dashComponent.layout) === null || _a === void 0 ? void 0 : _a.headingAlign),
                    'background-color': dashComponent.bgColor || 'transparent'
                });
                const $text = $('<span>').text(dashComponent.headingText || 'New Heading');
                $text.css({
                    'color': ((_b = dashComponent.styling) === null || _b === void 0 ? void 0 : _b.headingColor) || '#2c3e50',
                    'font-size': (((_c = dashComponent.styling) === null || _c === void 0 ? void 0 : _c.headingSize) || 24) + 'px',
                    'font-weight': ((_d = dashComponent.styling) === null || _d === void 0 ? void 0 : _d.isBold) ? 'bold' : 'normal',
                    'font-style': ((_e = dashComponent.styling) === null || _e === void 0 ? void 0 : _e.isItalic) ? 'italic' : 'normal'
                });
                $container.append($text);
                chartEl.append($container);
            }
            function getFlexAlign(align) {
                if (align === 'Right')
                    return 'flex-end';
                if (align === 'Center')
                    return 'center';
                return 'flex-start';
            }
            widgets.getFlexAlign = getFlexAlign;
            let $openFilterPopover = null;
            const TABLE_COLUMN_KEY_PREFIX = 'table-column:';
            function closeTableFilterPopover() {
                if ($openFilterPopover === null)
                    return;
                $openFilterPopover.remove();
                $openFilterPopover = null;
                $(document).off('mouseup.table-filter-popover');
            }
            function renderTable(element, chartEl, component) {
                var _a, _b, _c, _d, _e, _f, _g;
                const dataQueryPropName = 'dataQuery0';
                const dataQuery = component[dataQueryPropName];
                const cacheKey = `${component.id}.${dataQueryPropName}`;
                const rawData = dashboards.dataManager.getCachedResult(cacheKey);
                const isDesigner = $('body').hasClass('designerv2');
                const bgColor = component.bgColor;
                const hasBgColor = !!bgColor && bgColor !== 'transparent';
                const isDarkBg = hasBgColor && !appn.utils.isLightColor(bgColor);
                const tableStripeColor = isDarkBg ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)';
                const tableBorderColor = isDarkBg ? 'rgba(255, 255, 255, 0.18)' : 'rgba(0, 0, 0, 0.12)';
                const scrollbarThumbColor = isDarkBg ? 'rgba(255, 255, 255, 0.35)' : 'rgba(0, 0, 0, 0.3)';
                const textColor = isDarkBg ? '#ffffff' : '#212529';
                const mutedTextColor = isDarkBg ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.55)';
                const inputBgColor = isDarkBg ? 'rgba(255, 255, 255, 0.12)' : '#ffffff';
                const tintProperties = {
                    '--distill-fill': bgColor,
                    '--distill-table-stripe': tableStripeColor,
                    '--distill-table-border': tableBorderColor,
                    '--distill-scrollbar-thumb': scrollbarThumbColor,
                    '--distill-text-color': textColor,
                    '--distill-muted-text-color': mutedTextColor,
                    '--distill-input-bg': inputBgColor
                };
                chartEl.toggleClass('tinted', hasBgColor);
                if (hasBgColor)
                    chartEl.css(tintProperties);
                const columnFilters = !isDesigner && element.data('columnFilters') !== undefined
                    ? element.data('columnFilters')
                    : {};
                if (!isDesigner)
                    element.data('columnFilters', columnFilters);
                if (!isDesigner && !dashboards.dataManager.hasTableWindow(component.id))
                    dashboards.dataManager.setTableWindowOffset(component.id, 0);
                const isActiveFilter = (state) => !!(state && ((state.values && state.values.length > 0) || state.from || state.to));
                const getColumnForHeader = (header) => {
                    var _a;
                    const datasetRefs = dashboards.getDatasetRefsInDataQuery(dataQuery);
                    const resolve = (identifier) => {
                        if (!identifier)
                            return null;
                        const meta = dashboards.getContextualColumnMeta(identifier.datasetIndex, identifier.columnId, datasetRefs, dashboards.designer.getDatasets()).columnMeta;
                        return meta ? { metricIndex: null, identifier: identifier, meta: meta } : null;
                    };
                    if (dataQuery.aggregation) {
                        if (dataQuery.aggregation.groupBy && dashboards.getHeaderName(dataQuery.aggregation.groupBy, component) === header)
                            return resolve(dataQuery.aggregation.groupBy);
                        if (dataQuery.aggregation.breakDownBy && dashboards.getHeaderName(dataQuery.aggregation.breakDownBy, component) === header)
                            return resolve(dataQuery.aggregation.breakDownBy);
                        const metrics = dataQuery.aggregation.metrics || [];
                        for (let m = 0; m < metrics.length; m++) {
                            if (dashboards.getExpectedMetricHeader(component, dataQuery, metrics[m], m) === header)
                                return { metricIndex: m, identifier: null, meta: { id: '', displayName: header, designation: null, type: 'Number' } };
                        }
                    }
                    const proj = (((_a = dataQuery.projection) === null || _a === void 0 ? void 0 : _a.columns) || []).find(c => dashboards.getHeaderName(c, component) === header);
                    return proj ? resolve(proj) : null;
                };
                const isNumericColumn = (header) => {
                    var _a, _b;
                    if (((_a = getColumnForHeader(header)) === null || _a === void 0 ? void 0 : _a.meta.type) === 'Date')
                        return false;
                    if (((_b = getColumnForHeader(header)) === null || _b === void 0 ? void 0 : _b.meta.type) === 'Number')
                        return true;
                    const values = allRows.map(row => row[header]).filter(v => v !== null && v !== undefined && v !== '');
                    return values.length > 0 && values.every(v => !isNaN(Number(v)));
                };
                const buildFilters = (header) => {
                    var _a, _b, _c;
                    const state = columnFilters[header];
                    if (!isActiveFilter(state))
                        return [];
                    const resolved = getColumnForHeader(header);
                    if (!resolved)
                        return [];
                    if (resolved.metricIndex !== null) {
                        const metricFilterId = (_b = (((_a = dataQuery.aggregation) === null || _a === void 0 ? void 0 : _a.metrics) || [])[resolved.metricIndex]) === null || _b === void 0 ? void 0 : _b.filterId;
                        if (!metricFilterId || (!state.from && !state.to))
                            return [];
                        return [{ filterId: metricFilterId, from: state.from || '', to: state.to || '' }];
                    }
                    const filterId = (_c = resolved.identifier) === null || _c === void 0 ? void 0 : _c.filterId;
                    if (!filterId)
                        return [];
                    const selection = { filterId: filterId };
                    if (state.values && state.values.length > 0)
                        selection.values = state.values;
                    if (state.from || state.to) {
                        selection.from = state.from || '';
                        selection.to = state.to || '';
                    }
                    return [selection];
                };
                const activeFilterHeaders = Object.keys(columnFilters).filter(h => isActiveFilter(columnFilters[h]));
                const hasActiveFilters = !isDesigner && activeFilterHeaders.length > 0;
                const headers = (rawData === null || rawData === void 0 ? void 0 : rawData.Headers) || [];
                const allRows = (rawData === null || rawData === void 0 ? void 0 : rawData.ObjectResult) || [];
                if (allRows.length === 0 && !hasActiveFilters) {
                    if ($openFilterPopover !== null && $openFilterPopover.data('filter-component') === component.id)
                        closeTableFilterPopover();
                    chartEl.append($('<div>').addClass('text-center text-muted p-3').text(T('No data to display.')));
                    $(document).off(`click.tableExport_${component.id}`);
                    element.find('.table-export-menu').remove();
                    return;
                }
                const sortOverride = element.data('sortOverride');
                if ($openFilterPopover !== null
                    && $openFilterPopover.data('filter-component') === component.id
                    && JSON.stringify(allRows) !== $openFilterPopover.data('filter-signature'))
                    closeTableFilterPopover();
                const pageSize = ((_a = component.layout) === null || _a === void 0 ? void 0 : _a.pageSize) || 5;
                const isPaged = !isDesigner && (rawData === null || rawData === void 0 ? void 0 : rawData.TotalCount) !== undefined;
                const windowOffset = isPaged ? dashboards.dataManager.getTableWindowOffset(component.id) : 0;
                const totalCount = isPaged ? Math.max(rawData.TotalCount || 0, allRows.length) : allRows.length;
                let currentPage = element.data('currentPage') || 1;
                const pendingPage = element.data('pendingPage');
                const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
                if (pendingPage !== undefined) {
                    element.removeData('pendingPage');
                    if (pendingPage >= 1 && pendingPage <= totalPages)
                        currentPage = pendingPage;
                }
                if (currentPage > totalPages)
                    currentPage = totalPages;
                element.data('currentPage', currentPage);
                const absoluteStart = (currentPage - 1) * pageSize;
                const pageCovered = !isPaged || (absoluteStart >= windowOffset && absoluteStart < windowOffset + allRows.length);
                const pagedRows = pageCovered ? allRows.slice(absoluteStart - windowOffset, absoluteStart - windowOffset + pageSize) : [];
                const getTimeGrainForHeader = (header) => {
                    var _a, _b, _c;
                    if (dataQuery.aggregation) {
                        const groupBy = dataQuery.aggregation.groupBy;
                        if (groupBy && dashboards.getHeaderName(groupBy, component) === header)
                            return (_a = groupBy === null || groupBy === void 0 ? void 0 : groupBy.timeGrain) !== null && _a !== void 0 ? _a : dashboards.InsightTimeGrain.None;
                        const breakDownBy = dataQuery.aggregation.breakDownBy;
                        if (breakDownBy && dashboards.getHeaderName(breakDownBy, component) === header)
                            return (_b = breakDownBy === null || breakDownBy === void 0 ? void 0 : breakDownBy.timeGrain) !== null && _b !== void 0 ? _b : dashboards.InsightTimeGrain.None;
                    }
                    if (dataQuery.projection && dataQuery.projection.columns) {
                        const proj = dataQuery.projection.columns.find(c => dashboards.getHeaderName(c, component) === header);
                        if (proj)
                            return (_c = proj === null || proj === void 0 ? void 0 : proj.timeGrain) !== null && _c !== void 0 ? _c : dashboards.InsightTimeGrain.None;
                    }
                    return dashboards.InsightTimeGrain.None;
                };
                const sortTargetByHeader = new Map();
                const aggregation = dataQuery.aggregation;
                const hasAggregation = aggregation != null && (!!((_b = aggregation.groupBy) === null || _b === void 0 ? void 0 : _b.columnId) || !!((_c = aggregation.breakDownBy) === null || _c === void 0 ? void 0 : _c.columnId) || ((_e = (_d = aggregation.metrics) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) > 0);
                if (hasAggregation) {
                    const groupBy = aggregation.groupBy;
                    if (groupBy === null || groupBy === void 0 ? void 0 : groupBy.columnId) {
                        const header = dashboards.getHeaderName(groupBy, component);
                        if (header)
                            sortTargetByHeader.set(header, { type: 'Asc', column: { datasetIndex: groupBy.datasetIndex, columnId: groupBy.columnId, alias: groupBy.alias, timeGrain: groupBy.timeGrain } });
                    }
                    const breakDownBy = aggregation.breakDownBy;
                    if (breakDownBy === null || breakDownBy === void 0 ? void 0 : breakDownBy.columnId) {
                        const header = dashboards.getHeaderName(breakDownBy, component);
                        if (header)
                            sortTargetByHeader.set(header, { type: 'Asc', column: { datasetIndex: breakDownBy.datasetIndex, columnId: breakDownBy.columnId, alias: breakDownBy.alias, timeGrain: breakDownBy.timeGrain } });
                    }
                    ((_f = aggregation.metrics) !== null && _f !== void 0 ? _f : []).forEach((metric, index) => {
                        const header = dashboards.getExpectedMetricHeader(component, dataQuery, metric, index);
                        if (header)
                            sortTargetByHeader.set(header, { type: 'Asc', metricIndex: index });
                    });
                }
                else if ((_g = dataQuery.projection) === null || _g === void 0 ? void 0 : _g.columns) {
                    dataQuery.projection.columns.forEach(column => {
                        const header = dashboards.getHeaderName(column, component);
                        if (header)
                            sortTargetByHeader.set(header, { type: 'Asc', column: { datasetIndex: column.datasetIndex, columnId: column.columnId, alias: column.alias, timeGrain: column.timeGrain } });
                    });
                }
                const isSortableColumn = (header) => {
                    for (const row of allRows) {
                        const value = row[header];
                        if (value === null || value === undefined || value === '')
                            continue;
                        return typeof value === 'number' || typeof value === 'string';
                    }
                    return false;
                };
                const cycleSort = (header, sortOrder) => {
                    var _a;
                    let next;
                    if (!sortOverride || sortOverride.header !== header)
                        next = { header, dataQueryName: dataQueryPropName, orders: [Object.assign(Object.assign({}, sortOrder), { type: 'Asc' })] };
                    else if (((_a = sortOverride.orders[0]) === null || _a === void 0 ? void 0 : _a.type) === 'Asc')
                        next = { header, dataQueryName: dataQueryPropName, orders: [Object.assign(Object.assign({}, sortOrder), { type: 'Desc' })] };
                    else
                        next = null;
                    if (next)
                        element.data('sortOverride', next);
                    else
                        element.removeData('sortOverride');
                    element.data('currentPage', 1);
                    element.removeData('pendingPage');
                    if (!isDesigner) {
                        dashboards.dataManager.setTableWindowOffset(component.id, 0);
                        render(element, component);
                        distill.eventBus.publish(distill.EVENTS.DATA_REFRESH_REQUESTED, {
                            componentId: component.id,
                            viewName: cacheKey,
                            window: { offset: 0, limit: dashboards.dataManager.getTableWindowSize() }
                        });
                        return;
                    }
                    render(element, component);
                    distill.eventBus.publish(distill.EVENTS.DATA_REFRESH_REQUESTED, {
                        componentId: component.id,
                        viewName: cacheKey
                    });
                };
                const getDisplayValue = (header, value) => {
                    if (value === null || value === undefined || value === '')
                        return T('(blank)');
                    const timeGrain = getTimeGrainForHeader(header);
                    return timeGrain !== dashboards.InsightTimeGrain.None ? distill.dashboards.formatDateByGrain(String(value), timeGrain) : String(value);
                };
                const persistFilters = () => {
                    if (isDesigner)
                        return;
                    element.data('columnFilters', columnFilters);
                };
                const collectColumnFilters = () => Object.keys(columnFilters).reduce((acc, h) => acc.concat(buildFilters(h)), []);
                const triggerServerRefresh = () => {
                    if (isDesigner)
                        return;
                    element.data('currentPage', 1);
                    element.removeData('pendingPage');
                    dashboards.dataManager.setTableWindowOffset(component.id, 0);
                    distill.eventBus.publish(distill.EVENTS.DATA_REFRESH_REQUESTED, {
                        componentId: component.id,
                        filters: collectColumnFilters(),
                        window: { offset: 0, limit: dashboards.dataManager.getTableWindowSize() }
                    });
                };
                let globalFiltersSub = element.data('global-filters-sub');
                if (globalFiltersSub)
                    distill.eventBus.unsubscribe(globalFiltersSub);
                globalFiltersSub = distill.eventBus.subscribe(distill.EVENTS.DATA_REFRESH_REQUESTED, (payload) => {
                    if (payload.componentId)
                        return;
                    distill.dashboards.filterOptionsStore.clearCaches(TABLE_COLUMN_KEY_PREFIX);
                    distill.dashboards.filterOptionsStore.bumpGeneration();
                    if (payload.resetTablePaging && !isDesigner)
                        element.data('currentPage', 1);
                });
                element.data('global-filters-sub', globalFiltersSub);
                const buildFilterPills = () => {
                    const $bar = $('<div>').addClass('table-filter-pills d-flex flex-wrap align-items-center p-2 pb-0');
                    $bar.append($('<span>').addClass('table-filter-pills-label small font-weight-bold text-muted mr-1').text(T('Active Filters')));
                    activeFilterHeaders.forEach(header => {
                        const state = columnFilters[header];
                        const parts = [];
                        if (state.values && state.values.length > 0) {
                            parts.push({
                                text: state.values.map(key => getDisplayValue(header, key)).join(', '),
                                remove: () => {
                                    delete state.values;
                                    distill.dashboards.filterOptionsStore.deleteSelections(`${TABLE_COLUMN_KEY_PREFIX}${component.id}:${header}`);
                                    if (!isActiveFilter(state))
                                        delete columnFilters[header];
                                }
                            });
                        }
                        if (state.from || state.to) {
                            parts.push({
                                text: [state.from, state.to].filter(v => !!v).join(' \u2192 '),
                                remove: () => {
                                    delete state.from;
                                    delete state.to;
                                    if (!isActiveFilter(state))
                                        delete columnFilters[header];
                                }
                            });
                        }
                        parts.forEach(part => {
                            const $pill = $('<span>').addClass('table-filter-pill badge badge-pill badge-light').attr('title', `${header}: ${part.text}`);
                            $pill.append($('<span>').addClass('table-filter-pill-text').text(`${header}: ${part.text}`));
                            const $remove = $('<a>').addClass('table-filter-pill-remove').attr('href', 'javascript:void(0)').attr('title', T('Remove Filter')).html('<i class="fa fa-times"></i>');
                            $remove.on('click', () => {
                                part.remove();
                                persistFilters();
                                triggerServerRefresh();
                            });
                            $pill.append($remove);
                            $bar.append($pill);
                        });
                    });
                    const $clearAll = $('<a>').addClass('table-filter-clear-all small ml-1').attr('href', 'javascript:void(0)').text(T('Clear All'));
                    $clearAll.on('click', () => {
                        Object.keys(columnFilters).forEach(h => delete columnFilters[h]);
                        distill.dashboards.filterOptionsStore.deleteSelectionsByPrefix(`${TABLE_COLUMN_KEY_PREFIX}${component.id}:`);
                        persistFilters();
                        triggerServerRefresh();
                    });
                    $bar.append($clearAll);
                    return $bar;
                };
                const createFilterPopover = ($trigger, header) => {
                    const $popover = appn.utils.cloneTemplate('table-filter-popover');
                    $popover.css({ visibility: 'hidden', position: 'fixed', top: 0, left: 0 }).appendTo('body');
                    if (hasBgColor)
                        $popover.addClass('tinted').css(tintProperties);
                    $popover.data('filter-trigger', $trigger[0]);
                    $popover.data('filter-component', component.id);
                    $popover.data('filter-header', header);
                    $popover.data('filter-signature', JSON.stringify(allRows));
                    $openFilterPopover = $popover;
                    const rect = $trigger[0].getBoundingClientRect();
                    const popoverWidth = $popover.outerWidth() || 260;
                    const popoverHeight = $popover.outerHeight() || 320;
                    const left = Math.min(Math.max(rect.left, 8), window.innerWidth - popoverWidth - 8);
                    let top = rect.bottom + 4;
                    if (top + popoverHeight > window.innerHeight - 8)
                        top = Math.max(8, rect.top - popoverHeight - 4);
                    $popover.css({ visibility: 'visible', left: left, top: top });
                    $(document).on('mouseup.table-filter-popover', e => {
                        if ($openFilterPopover && $(e.target).closest('.table-filter-popover').length === 0 && $(e.target).closest('.table-filter-trigger').length === 0 && $(e.target).closest('.bootstrap-datetimepicker-widget').length === 0)
                            closeTableFilterPopover();
                    });
                    return $popover;
                };
                const openDateFilterPopover = ($trigger, header) => {
                    const state = columnFilters[header] || {};
                    const $popover = createFilterPopover($trigger, header);
                    const $dates = $popover.find('.table-filter-date-section').removeClass('d-none');
                    const $from = $dates.find('.table-filter-date-from').val(state.from || '');
                    const $to = $dates.find('.table-filter-date-to').val(state.to || '');
                    const $actions = $popover.find('.table-filter-actions').removeClass('d-none').addClass('mt-2');
                    const $apply = $actions.find('.table-filter-apply').prop('disabled', false);
                    const $clear = $actions.find('.table-filter-clear');
                    appn.ui.datePicker($popover.find('.datepicker'), undefined, 'YYYY-MM-DD');
                    $apply.on('click', () => {
                        const from = ($from.val() || '').trim();
                        const to = ($to.val() || '').trim();
                        if (!from && !to)
                            delete columnFilters[header];
                        else
                            columnFilters[header] = { from: from, to: to };
                        persistFilters();
                        closeTableFilterPopover();
                        triggerServerRefresh();
                    });
                    $clear.on('click', () => {
                        delete columnFilters[header];
                        persistFilters();
                        closeTableFilterPopover();
                        triggerServerRefresh();
                    });
                };
                const openFilterPopover = ($trigger, header) => {
                    var _a, _b, _c;
                    const isSameColumn = $openFilterPopover !== null
                        && $openFilterPopover.data('filter-header') === header
                        && $openFilterPopover.data('filter-component') === component.id;
                    closeTableFilterPopover();
                    if (isSameColumn)
                        return;
                    if (((_a = getColumnForHeader(header)) === null || _a === void 0 ? void 0 : _a.meta.type) === 'Date') {
                        openDateFilterPopover($trigger, header);
                        return;
                    }
                    const metricIndex = (_b = getColumnForHeader(header)) === null || _b === void 0 ? void 0 : _b.metricIndex;
                    if (metricIndex !== null && metricIndex !== undefined) {
                        openMetricFilterPopover($trigger, header, metricIndex);
                        return;
                    }
                    const activeValues = ((_c = columnFilters[header]) === null || _c === void 0 ? void 0 : _c.values) || null;
                    const selectionKey = `${TABLE_COLUMN_KEY_PREFIX}${component.id}:${header}`;
                    if (!distill.dashboards.filterOptionsStore.hasSelections(selectionKey))
                        distill.dashboards.filterOptionsStore.seedSelections(selectionKey, activeValues || []);
                    const $popover = createFilterPopover($trigger, header);
                    let $rangeFrom = null;
                    let $rangeTo = null;
                    if (isNumericColumn(header)) {
                        const rangeState = columnFilters[header] || {};
                        const $range = $popover.find('.table-filter-number-section').removeClass('d-none');
                        $rangeFrom = $range.find('.table-filter-range-from').val(rangeState.from || '');
                        $rangeTo = $range.find('.table-filter-range-to').val(rangeState.to || '');
                    }
                    const $searchGroup = $popover.find('.table-filter-search-group').removeClass('d-none');
                    const $search = $searchGroup.find('.table-filter-search');
                    const $searchClear = $searchGroup.find('.table-filter-search-clear');
                    const $loading = $popover.find('.table-filter-loading').removeClass('d-none');
                    const $limited = $popover.find('.table-filter-limited');
                    const $selectAll = $popover.find('.table-filter-select-all');
                    const $selectAllCb = $selectAll.find('.table-filter-select-all-cb');
                    const $values = $popover.find('.table-filter-values');
                    let hasBlanks = false;
                    const $actions = $popover.find('.table-filter-actions').removeClass('d-none');
                    const $apply = $actions.find('.table-filter-apply');
                    const $clear = $actions.find('.table-filter-clear');
                    const syncSelectAll = () => {
                        const total = $values.children().length;
                        const checked = $values.children().find('input[type="checkbox"]').filter(':checked').length;
                        $selectAllCb.prop('checked', total > 0 && checked === total);
                        $selectAllCb.prop('indeterminate', checked > 0 && checked < total);
                    };
                    $selectAll.on('change', 'input[type="checkbox"]', e => {
                        const checked = $(e.target).prop('checked');
                        $values.children().find('input[type="checkbox"]').prop('checked', checked);
                        syncSelections();
                        syncSelectAll();
                    });
                    $values.on('change', 'input[type="checkbox"]', () => {
                        syncSelections();
                        syncSelectAll();
                    });
                    const otherFilters = Object.keys(columnFilters)
                        .filter(h => h !== header)
                        .reduce((acc, h) => acc.concat(buildFilters(h)), []);
                    const filters = [...distill.dashboards.globalFilterPane.getAppliedFilters(), ...otherFilters];
                    let fetchToken = 0;
                    const buildValue = (value, display, count, isChecked) => {
                        const $row = $('<label>').addClass('table-filter-value').append($('<input type="checkbox">').val(value).prop('checked', isChecked), $('<span>').addClass('table-filter-value-label').text(display));
                        if (count !== null)
                            $row.append($('<span>').addClass('table-filter-count').text(String(count)));
                        return $row;
                    };
                    const syncSelections = () => {
                        const selections = distill.dashboards.filterOptionsStore.getSelections(selectionKey);
                        $values.find('.table-filter-value').each((_, el) => {
                            const $cb = $(el).find('input[type="checkbox"]');
                            const value = String($cb.val());
                            if ($cb.prop('checked'))
                                selections.set(value, { display: $(el).find('.table-filter-value-label').text(), count: Number($(el).find('.table-filter-count').text()) || 0 });
                            else
                                selections.delete(value);
                        });
                    };
                    const renderValues = (options, search) => {
                        var _a;
                        const selections = distill.dashboards.filterOptionsStore.getSelections(selectionKey);
                        options.forEach(o => {
                            if (selections.has(o.value))
                                selections.set(o.value, { display: getDisplayValue(header, o.value), count: o.count || 0 });
                        });
                        $values.empty();
                        const blankOption = options.find(o => o.value === '') || null;
                        const valueOptions = options.filter(o => o.value !== '');
                        if (search === '')
                            hasBlanks = blankOption !== null;
                        if (hasBlanks || selections.has(''))
                            $values.append(buildValue('', T('(blank)'), (_a = blankOption === null || blankOption === void 0 ? void 0 : blankOption.count) !== null && _a !== void 0 ? _a : null, selections.has('')));
                        const known = new Set(valueOptions.map(o => o.value));
                        if (search === '') {
                            selections.forEach((prior, value) => {
                                if (!known.has(value) && value !== '')
                                    $values.append(buildValue(value, prior.display, prior.count, true));
                            });
                        }
                        valueOptions.forEach(item => $values.append(buildValue(item.value, getDisplayValue(header, item.value), item.count || 0, selections.has(item.value))));
                        $selectAll.removeClass('d-none');
                        $values.removeClass('d-none');
                        const truncated = valueOptions.length >= distill.dashboards.FILTER_OPTIONS_LIMIT;
                        $limited.toggleClass('d-none', !truncated);
                        if (truncated)
                            $limited.text(T('Showing the top results only - search to find more.'));
                        $apply.prop('disabled', false);
                        syncSelectAll();
                        const newHeight = $popover.outerHeight() || 320;
                        const currentTop = parseFloat($popover.css('top')) || 0;
                        if (currentTop + newHeight > window.innerHeight - 8) {
                            const anchorTop = $trigger[0].getBoundingClientRect().top;
                            $popover.css('top', Math.max(8, anchorTop - newHeight - 4));
                        }
                        $apply.off('click').on('click', () => {
                            const selections = distill.dashboards.filterOptionsStore.getSelections(selectionKey);
                            const checkedKeys = Array.from(selections.keys());
                            const state = columnFilters[header] || {};
                            if (checkedKeys.length === 0 || (!search && !truncated && valueOptions.every(o => selections.has(o.value))))
                                delete state.values;
                            else
                                state.values = checkedKeys;
                            if ($rangeFrom && $rangeTo) {
                                const from = ($rangeFrom.val() || '').trim();
                                const to = ($rangeTo.val() || '').trim();
                                if (from || to) {
                                    state.from = from;
                                    state.to = to;
                                }
                                else {
                                    delete state.from;
                                    delete state.to;
                                }
                            }
                            if (!isActiveFilter(state))
                                delete columnFilters[header];
                            else
                                columnFilters[header] = state;
                            persistFilters();
                            closeTableFilterPopover();
                            triggerServerRefresh();
                        });
                    };
                    const loadValues = (search) => {
                        const token = ++fetchToken;
                        const cacheKey = `${selectionKey}:${JSON.stringify(filters)}`;
                        const cached = distill.dashboards.filterOptionsStore.getCached(cacheKey, search);
                        if (cached !== null) {
                            if (token !== fetchToken)
                                return;
                            $loading.addClass('d-none');
                            renderValues(cached, search);
                            return;
                        }
                        const revalidate = search === '' && distill.dashboards.filterOptionsStore.selectionsStale(selectionKey);
                        const candidates = revalidate ? Array.from(distill.dashboards.filterOptionsStore.getSelections(selectionKey).keys()) : null;
                        dashboards.dataManager.fetchFilterOptions(component, header, filters, search, candidates).then(items => {
                            if (token !== fetchToken || $openFilterPopover !== $popover || !$.contains(document.body, $popover[0]))
                                return;
                            $loading.addClass('d-none');
                            if (items === null) {
                                $values.empty();
                                $selectAll.addClass('d-none');
                                $limited.removeClass('d-none').removeClass('text-muted').addClass('text-danger').text(T('An error occurred. Please try again.'));
                                return;
                            }
                            if (revalidate && items.available !== null) {
                                distill.dashboards.filterOptionsStore.markSelectionsValidated(selectionKey);
                                const selections = distill.dashboards.filterOptionsStore.getSelections(selectionKey);
                                const available = new Set(items.available.map(i => i.value));
                                selections.forEach((_, value) => {
                                    if (!available.has(value))
                                        selections.delete(value);
                                });
                            }
                            if (search === '')
                                distill.dashboards.filterOptionsStore.setCached(cacheKey, items.options);
                            renderValues(items.options, search);
                        });
                    };
                    const syncSearchClear = () => {
                        $searchClear.toggle(($search.val() || '').trim().length > 0);
                    };
                    $search.on('input', () => {
                        const term = ($search.val() || '').trim();
                        syncSearchClear();
                        window.clearTimeout($search.data('searchTimer'));
                        $search.data('searchTimer', window.setTimeout(() => loadValues(term), 300));
                    });
                    $searchClear.on('click', () => {
                        $search.val('').trigger('input').trigger('focus');
                    });
                    syncSearchClear();
                    loadValues('');
                    $clear.on('click', () => {
                        delete columnFilters[header];
                        distill.dashboards.filterOptionsStore.deleteSelections(selectionKey);
                        persistFilters();
                        closeTableFilterPopover();
                        triggerServerRefresh();
                    });
                };
                const openMetricFilterPopover = ($trigger, header, metricIndex) => {
                    const $popover = createFilterPopover($trigger, header);
                    const rangeState = columnFilters[header] || {};
                    const $range = $popover.find('.table-filter-number-section').removeClass('d-none');
                    const $rangeFrom = $range.find('.table-filter-range-from').val(rangeState.from || '');
                    const $rangeTo = $range.find('.table-filter-range-to').val(rangeState.to || '');
                    const $actions = $popover.find('.table-filter-actions').removeClass('d-none');
                    const $apply = $actions.find('.table-filter-apply').prop('disabled', false);
                    const $clear = $actions.find('.table-filter-clear');
                    $apply.on('click', () => {
                        const from = ($rangeFrom.val() || '').trim();
                        const to = ($rangeTo.val() || '').trim();
                        const state = columnFilters[header] || {};
                        if (from || to) {
                            state.from = from;
                            state.to = to;
                        }
                        else {
                            delete state.from;
                            delete state.to;
                        }
                        if (!isActiveFilter(state))
                            delete columnFilters[header];
                        else
                            columnFilters[header] = state;
                        persistFilters();
                        closeTableFilterPopover();
                        triggerServerRefresh();
                    });
                    $clear.on('click', () => {
                        delete columnFilters[header];
                        persistFilters();
                        closeTableFilterPopover();
                        triggerServerRefresh();
                    });
                };
                const renderTableContent = (rowsToRender) => {
                    chartEl.empty();
                    if (hasActiveFilters && allRows.length === 0) {
                        chartEl.append(buildFilterPills());
                        chartEl.append($('<div>').addClass('text-center text-muted p-3').text(T('No matching entries.')));
                        return;
                    }
                    if (headers.length === 1) {
                        const $list = $('<div>').addClass('list-widget p-2');
                        const $ul = $('<ul>').addClass('list-group list-group-flush');
                        const timeGrain = getTimeGrainForHeader(headers[0]);
                        rowsToRender.forEach(row => {
                            let value = row[headers[0]];
                            if (value && timeGrain !== dashboards.InsightTimeGrain.None)
                                value = distill.dashboards.formatDateByGrain(String(value), timeGrain);
                            $ul.append($('<li>').addClass('list-group-item').text(value !== null && value !== undefined ? String(value) : ''));
                        });
                        $list.append($ul);
                        chartEl.append($list);
                    }
                    else if (headers.length > 1) {
                        const $tableContainer = $('<div>').addClass('table-responsive pr-2 pl-2 pb-2');
                        const $table = $('<table>').addClass('table table-sm');
                        if (!hasBgColor)
                            $table.addClass('table-striped');
                        const $thead = $('<thead>').appendTo($table);
                        const $tbody = $('<tbody>').appendTo($table);
                        const $headerRow = $('<tr>').appendTo($thead);
                        const numericHeaders = new Set(headers.filter(isNumericColumn));
                        const cellAlignClass = (header) => numericHeaders.has(header) ? 'table-number' : '';
                        headers.forEach(header => {
                            var _a;
                            const sortOrder = sortTargetByHeader.get(header);
                            const $th = $('<th>');
                            const alignClass = cellAlignClass(header);
                            if (alignClass)
                                $th.addClass(alignClass);
                            if (sortOrder && dashboards.isPublicView && isSortableColumn(header)) {
                                $th.addClass('table-sortable');
                                const $sortTarget = $('<span>').addClass('table-sort-target');
                                const $sort = $('<span>').addClass('table-sort-direction');
                                if (sortOverride && sortOverride.header === header)
                                    $sort.addClass(((_a = sortOverride.orders[0]) === null || _a === void 0 ? void 0 : _a.type) === 'Desc' ? 'sorting_desc' : 'sorting_asc');
                                $sortTarget.append($('<span>').addClass('table-header-label').text(header), $sort);
                                $sortTarget.on('click', () => cycleSort(header, sortOrder));
                                $th.append($sortTarget);
                            }
                            else
                                $th.append($('<span>').addClass('table-header-label').text(header));
                            if (!isDesigner) {
                                const $trigger = $('<a>').addClass('table-filter-trigger').attr('href', 'javascript:void(0)').attr('title', T('Filter')).html('<i class="fa fa-filter"></i>');
                                if (isActiveFilter(columnFilters[header]))
                                    $trigger.addClass('active');
                                $trigger.on('click', e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    openFilterPopover($trigger, header);
                                });
                                $th.append($trigger);
                            }
                            $headerRow.append($th);
                        });
                        rowsToRender.forEach(row => {
                            const $row = $('<tr>').appendTo($tbody);
                            headers.forEach(header => {
                                let value = row[header];
                                const timeGrain = getTimeGrainForHeader(header);
                                if (value && timeGrain !== dashboards.InsightTimeGrain.None)
                                    value = distill.dashboards.formatDateByGrain(String(value), timeGrain);
                                const $td = $('<td>').text(value !== null && value !== undefined ? String(value) : '');
                                const alignClass = cellAlignClass(header);
                                if (alignClass)
                                    $td.addClass(alignClass);
                                $row.append($td);
                            });
                        });
                        $tableContainer.append($table);
                        chartEl.append($tableContainer);
                    }
                    else {
                        chartEl.text('No columns selected.');
                        return;
                    }
                    if (hasActiveFilters)
                        chartEl.prepend(buildFilterPills());
                };
                const renderPagingControls = () => {
                    if (totalPages <= 1 && !hasActiveFilters)
                        return;
                    const $pager = $('<div>').addClass('table-pager d-flex justify-content-center align-items-center flex-wrap p-2 small');
                    if (totalPages > 1) {
                        const $prev = $('<button>').addClass('btn btn-sm btn-outline-secondary mr-2').html('<i class="fa fa-chevron-left"></i>').prop('disabled', currentPage === 1);
                        const $pageInfo = $('<span>').text(T('Page {0} of {1}', currentPage, totalPages));
                        const $next = $('<button>').addClass('btn btn-sm btn-outline-secondary ml-2').html('<i class="fa fa-chevron-right"></i>').prop('disabled', currentPage === totalPages);
                        const goToPage = (targetPage) => {
                            const targetStart = (targetPage - 1) * pageSize;
                            const covered = !isPaged || (targetStart >= windowOffset && targetStart < windowOffset + allRows.length);
                            if (covered) {
                                element.data('currentPage', targetPage);
                                render(element, component);
                                return;
                            }
                            const windowSize = dashboards.dataManager.getTableWindowSize();
                            const baseOffset = Math.floor(targetStart / windowSize) * windowSize;
                            dashboards.dataManager.setTableWindowOffset(component.id, baseOffset);
                            element.data('pendingPage', targetPage);
                            distill.eventBus.publish(distill.EVENTS.DATA_REFRESH_REQUESTED, {
                                componentId: component.id,
                                viewName: cacheKey,
                                window: { offset: baseOffset, limit: windowSize }
                            });
                        };
                        $prev.on('click', () => goToPage(currentPage - 1));
                        $next.on('click', () => goToPage(currentPage + 1));
                        $pager.append($prev, $pageInfo, $next);
                    }
                    const totalEntries = totalCount;
                    const startEntry = totalEntries === 0 ? 0 : absoluteStart + 1;
                    const endEntry = Math.min(absoluteStart + pageSize, totalEntries);
                    const summaryText = hasActiveFilters
                        ? T('Showing {0} to {1} of {2} filtered entries', startEntry, endEntry, totalEntries)
                        : T('Showing {0} to {1} of {2} entries', startEntry, endEntry, totalEntries);
                    $pager.append($('<span>').addClass('table-entry-summary text-muted ml-2').text(summaryText));
                    chartEl.append($pager);
                };
                const renderExportMenu = () => {
                    if (!distill.dashboards.isPublicView || !distill.dashboards.exportUrl)
                        return;
                    const eventNamespace = `tableExport_${component.id}`;
                    $(document).off(`click.${eventNamespace}`);
                    const $header = element.find('.card-header');
                    if (!$header.length)
                        return;
                    $header.find('.table-export-menu').remove();
                    const $menuContainer = $('<div>')
                        .addClass('table-export-menu dropdown');
                    const $btn = $('<button>')
                        .addClass('btn btn-sm btn-tool dropdown-toggle')
                        .attr({
                        'type': 'button',
                        'aria-haspopup': 'true',
                        'aria-expanded': 'false',
                        'title': T('Export Data')
                    })
                        .html('<i class="fa fa-ellipsis-v"></i>');
                    const $dropdownMenu = $('<div>')
                        .addClass('dropdown-menu dropdown-menu-right shadow-sm');
                    const EXPORT_ROW_CAP = 50000;
                    if (totalCount > EXPORT_ROW_CAP)
                        $dropdownMenu.append($('<div>').addClass('table-export-note px-3 py-2 small text-muted').text(T('Only the first 50,000 rows will be exported.')));
                    const $csvItem = $('<a>')
                        .addClass('dropdown-item export-csv-item')
                        .attr('href', 'javascript:void(0);')
                        .html(`<i class="fa fa-file-text-o mr-2 text-muted"></i>${T('Export to CSV (.csv)')}`);
                    const $excelItem = $('<a>')
                        .addClass('dropdown-item export-excel-item')
                        .attr('href', 'javascript:void(0);')
                        .html(`<i class="fa fa-file-excel-o mr-2 text-success"></i>${T('Export to Excel (.xlsx)')}`);
                    const closeMenu = () => {
                        $menuContainer.removeClass('show');
                        $dropdownMenu.removeClass('show');
                        $btn.attr('aria-expanded', 'false');
                    };
                    $btn.on('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const isShowing = $dropdownMenu.hasClass('show');
                        $('.table-export-menu .dropdown-menu.show').removeClass('show');
                        $('.table-export-menu.show').removeClass('show');
                        if (!isShowing) {
                            $menuContainer.addClass('show');
                            $dropdownMenu.addClass('show');
                            $btn.attr('aria-expanded', 'true');
                        }
                        else {
                            closeMenu();
                        }
                    });
                    $(document).on(`click.${eventNamespace}`, (e) => {
                        if (!$(e.target).closest($menuContainer).length)
                            closeMenu();
                    });
                    const runExport = (extension) => __awaiter(this, void 0, void 0, function* () {
                        var _a, _b;
                        const fileName = distill.dashboards.getExportFileName(component, extension);
                        const MAX_SHEET_NAME_LENGTH = 31;
                        const sheetName = (((_a = component.label) === null || _a === void 0 ? void 0 : _a.eng) || ((_b = component.title) === null || _b === void 0 ? void 0 : _b.eng) || 'Data').substring(0, MAX_SHEET_NAME_LENGTH);
                        if (!(yield distill.dashboards.publicView.ensureValidAccessToken()))
                            return;
                        distill.dashboards.exportTable({
                            url: distill.dashboards.exportUrl,
                            accessToken: distill.dashboards.publicView.getAccessToken() || '',
                            fileName: fileName,
                            sheetName: sheetName,
                            componentId: component.id,
                            filters: [...distill.dashboards.globalFilterPane.getAppliedFilters(), ...collectColumnFilters()],
                            sortOverrides: distill.dashboards.widgets.collectSortOverrides()
                        });
                    });
                    $csvItem.on('click', (e) => __awaiter(this, void 0, void 0, function* () {
                        e.preventDefault();
                        e.stopPropagation();
                        closeMenu();
                        yield runExport('csv');
                    }));
                    $excelItem.on('click', (e) => __awaiter(this, void 0, void 0, function* () {
                        e.preventDefault();
                        e.stopPropagation();
                        closeMenu();
                        yield runExport('xlsx');
                    }));
                    $dropdownMenu.append($csvItem, $excelItem);
                    $menuContainer.append($btn, $dropdownMenu);
                    $header.append($menuContainer);
                };
                renderTableContent(pagedRows);
                renderPagingControls();
                renderExportMenu();
            }
            function disposeChatCharts(charts) {
                charts.forEach(c => {
                    try {
                        c.observer.disconnect();
                        c.instance.dispose();
                    }
                    catch (_a) { }
                });
                charts.length = 0;
            }
            function renderChatChart($message, chart, component, charts) {
                const $container = $('<div class="distill-chat-chart"></div>');
                $message.append($container);
                const chartEl = $container.get(0);
                if (!chartEl)
                    return;
                const colors = resolveChatColors(component);
                const options = buildChatChartOptions(chart, colors);
                try {
                    const instance = echarts.init(chartEl);
                    instance.setOption(options, true);
                    const resizeObserver = new ResizeObserver(() => {
                        instance.resize();
                    });
                    resizeObserver.observe(chartEl);
                    charts.push({ instance, observer: resizeObserver });
                }
                catch (_a) { }
            }
            function resolveChatColors(component) {
                var _a, _b, _c, _d;
                if (((_a = component.styling) === null || _a === void 0 ? void 0 : _a.colorPalette) === 'Custom' && ((_c = (_b = component.styling) === null || _b === void 0 ? void 0 : _b.customColorPalette) === null || _c === void 0 ? void 0 : _c.length))
                    return component.styling.customColorPalette;
                const paletteName = ((_d = component.styling) === null || _d === void 0 ? void 0 : _d.colorPalette) || 'Vibrant';
                return dashboards.DashColorPalettes[paletteName] || dashboards.DashColorPalettes['Vibrant'];
            }
            const CHAT_CHART_DEFAULTS = {
                fontColor: '#666666',
                fontSize: 14,
                tooltipBg: 'rgba(50, 50, 50, 0.95)',
                tooltipTextColor: '#ffffff',
                axisLineColor: '#ccc',
                splitLineColor: '#eee',
                outlineColor: '#ffffff',
                barMaxWidth: 20
            };
            function buildChatChartOptions(chart, colors) {
                const type = (chart.Type || 'bar').toLowerCase();
                const labels = chart.Labels || [];
                const series = chart.Series || [];
                const options = {
                    color: colors,
                    tooltip: {
                        trigger: type === 'pie' ? 'item' : 'axis',
                        confine: true,
                        appendTo: 'body',
                        borderWidth: 0,
                        padding: 10,
                        backgroundColor: CHAT_CHART_DEFAULTS.tooltipBg,
                        textStyle: { color: CHAT_CHART_DEFAULTS.tooltipTextColor }
                    },
                    grid: { top: '15%', bottom: '10%', left: '10%', right: '10%', containLabel: true }
                };
                const baseLegend = {
                    type: 'scroll',
                    textStyle: { color: CHAT_CHART_DEFAULTS.fontColor, fontSize: CHAT_CHART_DEFAULTS.fontSize },
                    itemStyle: { borderColor: CHAT_CHART_DEFAULTS.outlineColor, borderWidth: 2 }
                };
                if (type === 'pie') {
                    const pieData = labels.map((label, i) => {
                        var _a, _b, _c;
                        return ({
                            name: label,
                            value: (_c = (_b = (_a = series[0]) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b[i]) !== null && _c !== void 0 ? _c : 0
                        });
                    });
                    options.legend = Object.assign(Object.assign({}, baseLegend), { bottom: 0 });
                    options.series = [{
                            type: 'pie',
                            radius: ['0%', '75%'],
                            center: ['50%', '50%'],
                            itemStyle: { borderRadius: 5, borderColor: CHAT_CHART_DEFAULTS.outlineColor, borderWidth: 2 },
                            label: { show: true, formatter: '{b}: {d}%', fontSize: CHAT_CHART_DEFAULTS.fontSize },
                            data: pieData
                        }];
                }
                else {
                    const stacked = chart.Stacked === true;
                    const isLine = type === 'line';
                    options.legend = Object.assign(Object.assign({}, baseLegend), { bottom: 0 });
                    options.xAxis = {
                        type: 'category',
                        data: labels,
                        boundaryGap: !isLine,
                        axisLabel: {
                            rotate: labels.length > 6 ? 30 : 0,
                            color: CHAT_CHART_DEFAULTS.fontColor,
                            fontSize: CHAT_CHART_DEFAULTS.fontSize,
                            interval: 'auto',
                            hideOverlap: true
                        },
                        axisLine: { lineStyle: { color: CHAT_CHART_DEFAULTS.axisLineColor } },
                        axisTick: { show: false }
                    };
                    options.yAxis = {
                        type: 'value',
                        axisLabel: { color: CHAT_CHART_DEFAULTS.fontColor, fontSize: CHAT_CHART_DEFAULTS.fontSize },
                        splitLine: { lineStyle: { type: 'dashed', color: CHAT_CHART_DEFAULTS.splitLineColor } },
                        axisLine: { show: false },
                        axisTick: { show: false }
                    };
                    options.series = series.map(s => ({
                        name: s.Name,
                        type: isLine ? 'line' : 'bar',
                        data: s.Data,
                        smooth: isLine,
                        connectNulls: isLine,
                        stack: stacked ? 'total' : undefined,
                        barMaxWidth: CHAT_CHART_DEFAULTS.barMaxWidth,
                        itemStyle: { borderRadius: type === 'bar' ? (stacked ? [0, 0, 0, 0] : [3, 3, 0, 0]) : undefined }
                    }));
                }
                return options;
            }
            function collectSortOverrides() {
                var _a;
                const overrides = [];
                const visit = (components) => {
                    for (const component of components) {
                        if (component.type === dashboards.ComponentType.table) {
                            const override = $(`#${component.id}`).data('sortOverride');
                            if (override && override.orders.length > 0)
                                overrides.push({ componentId: component.id, dataQueryName: override.dataQueryName, sortOrders: override.orders });
                        }
                        if (component.children)
                            visit(component.children);
                    }
                };
                if ((_a = dashboards.designer === null || dashboards.designer === void 0 ? void 0 : dashboards.designer._design) === null || _a === void 0 ? void 0 : _a.components)
                    visit(dashboards.designer._design.components);
                return overrides;
            }
            widgets.collectSortOverrides = collectSortOverrides;
            function renderDistillQuery(element, chartEl, component) {
                function renderMarkdownToSafeHtml(md) {
                    if (!md)
                        return '';
                    let text = md.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
                    const escapeHtml = (s) => s
                        .replace(/&/g, '&amp;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#39;');
                    text = escapeHtml(text);
                    const codeBlocks = [];
                    let codeIndex = 0;
                    text = text.replace(/```(\w+)?\s*\n([\s\S]*?)```/g, (_m, lang, code) => {
                        const idx = codeIndex++;
                        const placeholder = `@@DISTILLCODEBLOCK${idx}@@`;
                        const language = (lang || '').trim().toLowerCase();
                        const langClass = language ? ` class="language-${language}"` : '';
                        const html = `
                    <div class="card my-2 code-card border-light shadow-sm">
                        ${language ? `<div class="card-header py-1 px-2 bg-light text-muted small text-uppercase font-weight-bold">${language}</div>` : ''}
                        <div class="card-body p-0">
                            <pre class="m-0 rounded-0 bg-white"><code${langClass} class="d-block p-3 text-dark" style="font-size: 0.9em;">${code}</code></pre>
                        </div>
                    </div>`;
                        codeBlocks.push({ placeholder, html });
                        return placeholder;
                    });
                    text = text.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" class="img-fluid rounded shadow-sm my-2" />');
                    text = text.replace(/\[([^\]]+)\]\(([^)\s]+)(?:\s+(?:"|&quot;)([^"]+)(?:"|&quot;))?\)/g, (_m, txt, url, title) => {
                        const titleAttr = title ? ` title="${title}"` : '';
                        return `<a href="${url}"${titleAttr} target="_blank" rel="noopener noreferrer" class="text-primary font-weight-bold">${txt}</a>`;
                    });
                    text = text.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
                    text = text.replace(/__([^_]+)__/g, '<strong>$1</strong>');
                    text = text.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, '$1<em>$2</em>');
                    text = text.replace(/(^|[^a-zA-Z0-9])_([^_]+)_(?![a-zA-Z0-9])/g, '$1<em>$2</em>');
                    text = text.replace(/~~([^~]+)~~/g, '<del>$1</del>');
                    text = text.replace(/`([^`\n]+)`/g, '<code class="text-danger bg-light px-1 rounded" style="font-size: 0.9em;">$1</code>');
                    const lines = text.split('\n');
                    let htmlOut = '';
                    let inUl = false;
                    let inOl = false;
                    let inBlockquote = false;
                    let inTable = false;
                    const closeAll = () => {
                        if (inUl) {
                            htmlOut += '</ul>';
                            inUl = false;
                        }
                        if (inOl) {
                            htmlOut += '</ol>';
                            inOl = false;
                        }
                        if (inBlockquote) {
                            htmlOut += '</blockquote>';
                            inBlockquote = false;
                        }
                        if (inTable) {
                            htmlOut += '</tbody></table></div>';
                            inTable = false;
                        }
                    };
                    for (let i = 0; i < lines.length; i++) {
                        const rawLine = lines[i];
                        const line = rawLine.trimEnd();
                        const trimmed = line.trim();
                        if (/^@@DISTILLCODEBLOCK\d+@@$/.test(trimmed)) {
                            closeAll();
                            htmlOut += trimmed;
                            continue;
                        }
                        if (trimmed.length === 0) {
                            closeAll();
                            continue;
                        }
                        if (/^(\*{3,}|-{3,}|_{3,})$/.test(trimmed)) {
                            closeAll();
                            htmlOut += '<hr class="my-4" />';
                            continue;
                        }
                        const hMatch = /^\s*(#{1,6})\s+(.*)$/.exec(line);
                        if (hMatch) {
                            closeAll();
                            const level = hMatch[1].length;
                            htmlOut += `<h${level} class="mt-4 mb-2 font-weight-bold">${hMatch[2]}</h${level}>`;
                            continue;
                        }
                        const qMatch = /^&gt;\s?(.*)$/.exec(trimmed);
                        if (qMatch) {
                            closeAll();
                            if (!inBlockquote) {
                                htmlOut += '<blockquote class="blockquote p-3 bg-light border-left border-primary ml-0 my-3" style="border-width: 4px !important; font-size: 1rem;">';
                                inBlockquote = true;
                            }
                            else {
                                htmlOut += '<br/>';
                            }
                            htmlOut += qMatch[1];
                            continue;
                        }
                        if (inBlockquote) {
                            htmlOut += '</blockquote>';
                            inBlockquote = false;
                        }
                        const ulMatch = /^\s*[-*+]\s+(.*)$/.exec(line);
                        if (ulMatch) {
                            if (inOl) {
                                htmlOut += '</ol>';
                                inOl = false;
                            }
                            if (inTable) {
                                htmlOut += '</tbody></table></div>';
                                inTable = false;
                            }
                            if (!inUl) {
                                htmlOut += '<ul class="pl-4 mb-3">';
                                inUl = true;
                            }
                            htmlOut += `<li>${ulMatch[1]}</li>`;
                            continue;
                        }
                        const olMatch = /^\s*\d+\.\s+(.*)$/.exec(line);
                        if (olMatch) {
                            if (inUl) {
                                htmlOut += '</ul>';
                                inUl = false;
                            }
                            if (inTable) {
                                htmlOut += '</tbody></table></div>';
                                inTable = false;
                            }
                            if (!inOl) {
                                htmlOut += '<ol class="pl-4 mb-3">';
                                inOl = true;
                            }
                            htmlOut += `<li>${olMatch[1]}</li>`;
                            continue;
                        }
                        if (trimmed.startsWith('|') && trimmed.endsWith('|')) {
                            if (/^\|?[\s-:]+(\|[\s-:]+)*\|?$/.test(trimmed))
                                continue;
                            if (inUl) {
                                htmlOut += '</ul>';
                                inUl = false;
                            }
                            if (inOl) {
                                htmlOut += '</ol>';
                                inOl = false;
                            }
                            if (inBlockquote) {
                                htmlOut += '</blockquote>';
                                inBlockquote = false;
                            }
                            const rowContent = trimmed.split('|').map(c => c.trim()).filter((c, idx, arr) => {
                                if (idx === 0 && c === '')
                                    return false;
                                if (idx === arr.length - 1 && c === '')
                                    return false;
                                return true;
                            });
                            if (!inTable) {
                                htmlOut += '<div class="table-responsive my-3"><table class="table table-bordered table-sm table-striped bg-white"><thead><tr>';
                                rowContent.forEach(cell => { htmlOut += `<th>${cell}</th>`; });
                                htmlOut += '</tr></thead><tbody>';
                                inTable = true;
                            }
                            else {
                                htmlOut += '<tr>';
                                rowContent.forEach(cell => { htmlOut += `<td>${cell}</td>`; });
                                htmlOut += '</tr>';
                            }
                            continue;
                        }
                        if (inTable) {
                            htmlOut += '</tbody></table></div>';
                            inTable = false;
                        }
                        closeAll();
                        htmlOut += `<p class="mb-2 text-wrap text-break">${line}</p>`;
                    }
                    closeAll();
                    for (const block of codeBlocks) {
                        htmlOut = htmlOut.split(block.placeholder).join(block.html);
                    }
                    const sanitizeHtml = (unsafeHtml) => {
                        const temp = document.createElement('div');
                        temp.innerHTML = unsafeHtml;
                        const allowed = {
                            div: ['class', 'style'], pre: ['class', 'style'], code: ['class', 'style'],
                            p: ['class'], br: [], strong: [], em: [], del: [],
                            ul: ['class'], ol: ['class'], li: [],
                            blockquote: ['class', 'style'], hr: ['class'],
                            table: ['class'], thead: [], tbody: [], tr: [], th: [], td: [],
                            h1: ['class'], h2: ['class'], h3: ['class'], h4: ['class'], h5: ['class'], h6: ['class'],
                            a: ['href', 'title', 'target', 'rel', 'class'],
                            img: ['src', 'alt', 'title', 'class']
                        };
                        const isAllowedTag = (tag) => Object.prototype.hasOwnProperty.call(allowed, tag);
                        const walk = (node) => {
                            var _a;
                            const nodeType = node.nodeType;
                            if (nodeType === Node.ELEMENT_NODE) {
                                const el = node;
                                const tag = el.tagName.toLowerCase();
                                if (!isAllowedTag(tag)) {
                                    const replacement = document.createTextNode(el.textContent || '');
                                    (_a = el.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(replacement, el);
                                    return;
                                }
                                const allowedAttrs = allowed[tag];
                                const attrs = Array.from(el.attributes);
                                for (const a of attrs) {
                                    if (allowedAttrs.indexOf(a.name) === -1)
                                        el.removeAttribute(a.name);
                                }
                                if (tag === 'a') {
                                    const href = el.getAttribute('href') || '';
                                    const lower = href.trim().toLowerCase();
                                    const safe = lower.startsWith('http://') || lower.startsWith('https://') || lower.startsWith('mailto:')
                                        || (lower.startsWith('/') && !lower.startsWith('//')) || lower.startsWith('#');
                                    if (!safe)
                                        el.removeAttribute('href');
                                }
                                const children = Array.from(el.childNodes);
                                for (const child of children)
                                    walk(child);
                            }
                            else if (nodeType === Node.DOCUMENT_FRAGMENT_NODE || nodeType === Node.DOCUMENT_NODE) {
                                const children = Array.from(node.childNodes);
                                for (const child of children)
                                    walk(child);
                            }
                        };
                        walk(temp);
                        return temp.innerHTML;
                    };
                    return sanitizeHtml(htmlOut);
                }
                let welcomeMessage = component.welcomeMessage;
                if (!welcomeMessage || welcomeMessage.trim() === '')
                    welcomeMessage = 'Hello!\nHow can I help you?';
                const styling = component.styling || {};
                const buttonColor = styling.sendButtonStyle;
                const buttonTextColor = styling.sendButtonTextColor;
                const buttonIcon = 'fa-play';
                const responseColor = styling.responseMessageBgColor;
                const responseTextColor = styling.responseMessageTextColor;
                const sentColor = styling.sentMessageBgColor;
                const sentTextColor = styling.sentMessageTextColor;
                const bgColor = component.bgColor || 'transparent';
                const headerBgColor = styling.headerBgColor;
                const inputBgColor = styling.inputBgColor || '#ffffff';
                let chatHistory = element.data('chatHistory') || [];
                let chatHistorySignature = element.data('chatSignature') || null;
                let chatChartData = element.data('chatCharts') || [];
                disposeChatCharts(element.data('chat-chart-handles') || []);
                const chatCharts = [];
                element.data('chat-chart-handles', chatCharts);
                let $clearButton;
                const $header = element.find('.card-header');
                if ($header.length > 0) {
                    if (headerBgColor)
                        $header.css('background-color', headerBgColor);
                    const $label = $header.find('.componentLabel');
                    if ($label.length > 0 && $label.find('.ask-beta-tag').length === 0)
                        $label.append('<span class="ask-beta-tag badge badge-warning ml-2" style="vertical-align: middle;">' + T('Beta') + '</span>');
                    $header.css('position', 'relative');
                    $clearButton = $header.find('.clear-chat-btn');
                    if ($clearButton.length === 0) {
                        $clearButton = $(`
                    <a href="#" class="btn btn-sm btn-icon-only clear-chat-btn" title="Clear Chat" 
                       style="position: absolute; top: 50%; right: 8px; transform: translateY(-50%); margin: 0;">
                        <i class="fa fa-eraser"></i>
                    </a>
                `);
                        $clearButton.on('click', (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            distill.eventBus.publish(dashboards.DASH_EVENTS.AI_QUERY_CLEAR, { componentId: component.id });
                        });
                        $header.append($clearButton);
                    }
                }
                chartEl.append(`
            <div class="distill-query-widget-wrapper" style="background-color: ${bgColor};">
                <div class="distill-query-log"></div>
                <div class="modal-footer">
                    <div class="input-group">
                        <input type="text" class="chat-input form-control" placeholder="Ask a question..." 
                               style="background-color: ${inputBgColor};">
                        <div class="input-group-append">
                            <button class="send-button btn" title="Send" type="button" 
                                    style="background-color: ${buttonColor}; border-color: ${buttonColor}; color: ${buttonTextColor};">
                                <i class="fa ${buttonIcon}"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `);
                let $sendButton = chartEl.find('.send-button');
                let $chatInput = chartEl.find('.chat-input');
                let $chatLog = chartEl.find('.distill-query-log');
                $chatLog.empty();
                addMessageToLog(welcomeMessage, 'model');
                chatHistory.forEach((message, i) => {
                    const messageCharts = chatChartData[i];
                    if (message.Role === 'model' && messageCharts && messageCharts.length > 0)
                        appendAssistantMessage(message.Parts[0].Text, messageCharts);
                    else
                        addMessageToLog(message.Parts[0].Text, message.Role);
                });
                $sendButton.on('click', () => sendMessage());
                $chatInput.on('keypress', (e) => {
                    if (e.key !== 'Enter')
                        return;
                    e.preventDefault();
                    sendMessage();
                });
                let $loadingEl = null;
                let sendEventSub = element.data('send-event-sub');
                if (sendEventSub)
                    distill.eventBus.unsubscribe(sendEventSub);
                sendEventSub = distill.eventBus.subscribe(dashboards.DASH_EVENTS.AI_QUERY_SEND, (payload) => {
                    if (payload.component.id !== component.id)
                        return;
                    $chatInput.val('');
                    $chatInput.prop('disabled', true);
                    $sendButton.prop('disabled', true);
                    $clearButton === null || $clearButton === void 0 ? void 0 : $clearButton.prop('disabled', true);
                    addMessageToLog(payload.userQuery, 'user');
                    $loadingEl = addMessageToLog("thinking...", 'loading');
                });
                element.data('send-event-sub', sendEventSub);
                let resultEventSub = element.data('result-event-sub');
                if (resultEventSub)
                    distill.eventBus.unsubscribe(resultEventSub);
                resultEventSub = distill.eventBus.subscribe(dashboards.DASH_EVENTS.AI_QUERY_RESULT, (result) => {
                    if (result.componentId !== component.id)
                        return;
                    try {
                        $loadingEl === null || $loadingEl === void 0 ? void 0 : $loadingEl.remove();
                        let answer = null;
                        let charts = null;
                        if (result.success && result.response) {
                            const parsed = typeof result.response === 'string' ? JSON.parse(result.response) : result.response;
                            if (parsed.ErrorType === dashboards.InternalDistillErrorType.UsageLimitExceeded) {
                                const action = result.upgradeUrl
                                    ? ` [${T('Upgrade to Pro')}](${result.upgradeUrl})`
                                    : ` ${T('Contact your administrator to upgrade your user account.')}`;
                                addMessageToLog(`${parsed.Answer || ''}${action}`, 'bot');
                                return;
                            }
                            if (parsed.Answer)
                                answer = parsed.Answer;
                            if (parsed.Charts && parsed.Charts.length > 0)
                                charts = parsed.Charts;
                            const newTurns = parsed.Turns;
                            if (newTurns && newTurns.length > 0) {
                                chatHistory.push(...newTurns);
                                newTurns.forEach((turn, i) => chatChartData.push(i === newTurns.length - 1 ? (charts || []) : null));
                                chatHistorySignature = parsed.HistorySignature || null;
                                element.data('chatHistory', chatHistory);
                                element.data('chatSignature', chatHistorySignature);
                                element.data('chatCharts', chatChartData);
                            }
                        }
                        appendAssistantMessage(answer || '', charts || []);
                    }
                    finally {
                        $chatInput.prop('disabled', false);
                        $sendButton.prop('disabled', false);
                        $clearButton === null || $clearButton === void 0 ? void 0 : $clearButton.prop('disabled', false);
                        $chatInput.trigger('focus');
                    }
                });
                element.data('result-event-sub', resultEventSub);
                let clearEventSub = element.data('clear-event-sub');
                if (clearEventSub)
                    distill.eventBus.unsubscribe(clearEventSub);
                clearEventSub = distill.eventBus.subscribe(dashboards.DASH_EVENTS.AI_QUERY_CLEAR, (payload) => {
                    if (payload.componentId !== component.id)
                        return;
                    chatHistory = [];
                    chatHistorySignature = null;
                    chatChartData = [];
                    disposeChatCharts(chatCharts);
                    $chatLog.empty();
                    addMessageToLog(welcomeMessage, 'model');
                    element.data('chatHistory', chatHistory);
                    element.data('chatSignature', chatHistorySignature);
                    element.data('chatCharts', chatChartData);
                    $chatInput.val('').prop('disabled', false);
                    $sendButton.prop('disabled', false);
                    if ($clearButton)
                        $clearButton.prop('disabled', false);
                    if ($loadingEl) {
                        $loadingEl.remove();
                        $loadingEl = null;
                    }
                    $chatInput.trigger('focus');
                });
                element.data('clear-event-sub', clearEventSub);
                function sendMessage() {
                    const userQuery = $chatInput.val();
                    if (!userQuery || userQuery.trim() === '')
                        return;
                    distill.eventBus.publish(dashboards.DASH_EVENTS.AI_QUERY_SEND, {
                        component: component,
                        userQuery: userQuery,
                        history: chatHistory,
                        historySignature: chatHistorySignature
                    });
                }
                function addMessageToLog(content, type) {
                    const $message = $('<div class="distill-message"></div>');
                    const displayType = (type === 'model') ? 'bot' : type;
                    $message.addClass(displayType);
                    const safeContent = content || "";
                    if (displayType === 'bot' && type !== 'loading')
                        $message.html(renderMarkdownToSafeHtml(safeContent));
                    else
                        $message.text(safeContent);
                    if (displayType === 'user') {
                        $message.css('background-color', sentColor);
                        $message.css('color', sentTextColor);
                        $message.css('text-align', 'right');
                    }
                    else {
                        $message.css('background-color', responseColor);
                        $message.css('color', responseTextColor);
                        $message.css('text-align', 'left');
                    }
                    $chatLog.append($message);
                    $chatLog.scrollTop($chatLog[0].scrollHeight);
                    return $message;
                }
                function appendAssistantMessage(answer, charts) {
                    if (answer) {
                        if (charts.length > 0 && answer.indexOf('<!--chart-->') !== -1) {
                            const segments = answer.split('<!--chart-->');
                            const $msg = addMessageToLog('', 'bot');
                            $msg.empty();
                            for (let i = 0; i < segments.length; i++) {
                                const seg = segments[i].trim();
                                if (seg)
                                    $msg.append($(renderMarkdownToSafeHtml(seg)));
                                if (i < charts.length)
                                    renderChatChart($msg, charts[i], component, chatCharts);
                            }
                            if (charts.length > segments.length - 1) {
                                for (let i = segments.length - 1; i < charts.length; i++)
                                    renderChatChart($msg, charts[i], component, chatCharts);
                            }
                        }
                        else {
                            const $msg = addMessageToLog(answer, 'bot');
                            if (charts.length > 0)
                                charts.forEach(chart => renderChatChart($msg, chart, component, chatCharts));
                        }
                    }
                    else if (charts.length > 0) {
                        const $msg = addMessageToLog('', 'bot');
                        $msg.empty();
                        charts.forEach(chart => renderChatChart($msg, chart, component, chatCharts));
                    }
                    else {
                        addMessageToLog(T('Sorry, something went wrong. Please try again.'), 'bot');
                    }
                }
            }
        })(widgets = dashboards.widgets || (dashboards.widgets = {}));
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
